const groupEndpoint = "/api/kpi/kpi-groups";

const ENDPOINTS = {
  KPIGroup: (storeId: string) => `${groupEndpoint}?storeId=${storeId}`,
  addKPIGroup: () => groupEndpoint,
  deleteKPIGroup: () => groupEndpoint,
};

export { ENDPOINTS };
